import React, { useState, useEffect } from "react";
import { parseUrl } from "query-string";
import { string, func, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import Button from "../../atoms/Button";
import WithSSO from "../../with-sso";

import "./popupOverlay.m.css";

const PopupOverlay = ({
  popupMessage,
  onClickHandler,
  showButton = true,
  lang = "bn",
  authHost,
  currentPath,
  sketchesHost,
  buttonType = "",
  buttonContent = "Okay",
}) => {
  const [callbackUrl, setCallbackUrl] = useState(null);
  const [redirectUrl, setRedirectUrl] = useState(null);
  const buttonText = buttonType === "login" && buttonContent ? buttonContent : "Login";

  const params = parseUrl(currentPath);

  const getRedirectUrl = (defaultRedirectUrl) => {
    const redirectUrl = get(params, ["query", "redirect-url"], defaultRedirectUrl);
    const isHashPresent = redirectUrl.substr(0, redirectUrl.indexOf("#"));
    const finalRedirectUrl = isHashPresent.length > 0 ? isHashPresent : redirectUrl;
    setRedirectUrl(finalRedirectUrl);
  };

  useEffect(() => {
    setCallbackUrl(get(params, ["query", "callback-url"], global.location.origin));
    if (params.url.includes("sign-in-page") || params.url.includes("sign-up-page")) {
      getRedirectUrl(sketchesHost);
    } else {
      params.url.includes("verify-email") ? getRedirectUrl(sketchesHost) : getRedirectUrl(global.location.href);
    }
  }, [params]);

  return (
    <div className="popup-wrapper">
      <div styleName={`popup-container ${lang}-container`} className="popup-container">
        <div styleName="popup-content">{popupMessage}</div>
        {showButton && buttonType !== "login" && (
          <Button content={buttonContent} buttonType="type3" onClick={onClickHandler} />
        )}
        {buttonType === "login" && (
          <WithSSO
            ssoHost={authHost}
            signInPath="/sign-in-page"
            signUpPath="/sign-up-page"
            redirectUrl={redirectUrl}
            callbackUrl={callbackUrl}
          >
            {({ signInHref }) => (
              <Link href={signInHref}>
                <Button content={buttonText} buttonType="type3" />
              </Link>
            )}
          </WithSSO>
        )}
      </div>
      <div styleName="bg-overlay"></div>
    </div>
  );
};

PopupOverlay.propTypes = {
  popupMessage: string,
  onClickHandler: func,
  showButton: bool,
  lang: string,
  authHost: string,
  currentPath: string,
  sketchesHost: string,
  buttonType: string,
  buttonContent: string,
};

const mapStateToProps = (state) => ({
  authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
  currentPath: get(state, ["qt", "currentPath"], ""),
  sketchesHost: get(state, ["qt", "config", "sketches-host"], "https://www.prothomalo.com"),
});

export default connect(mapStateToProps)(PopupOverlay);
